/**
 * Modernizr in npm not builded and can not be required with webpack
 */

module.exports = require('imports-loader?this=>window!exports-loader?window.Modernizr!./modernizr.js');
